import React from 'react';
import { connect } from 'react-redux';
import * as R from 'ramda';

import { changeCurrentOrder } from '../../Actions/changeCurrentOrder';
import Counter from './Counter';

const CurrentOrder = props => {
  const { goods, changeOrder, lastGoodId, t } = props;

  const delGood = goodId => {
    const changeGoods = goods.map(i => {
      if (i.shopGood === goodId) {
        return { ...i, count: 0 };
      }
      return i;
    });
    changeOrder({ goods: changeGoods }, 0, 1);
  };

  const goodItem = good => {
    if (!good.data) return null;
    const lang = t.language;
    const goodLocData = good.data.locData[lang];
    return (
      <div key={good.shopGood} className="product-item">
        <div className="name">{goodLocData.name}</div>
        <Counter good={good} />
        <div className="price">{good.data.cost * good.count} ₽</div>
        <div className="delete-product" onClick={() => delGood(good.data.id)}>
          ×
        </div>
      </div>
    );
  };

  const withoutLast = R.filter(i => i.shopGood !== lastGoodId, goods);
  return (
    <div>
      {lastGoodId && withoutLast.legth ? (
        <p className="title-product-item">{t['Так же в корзине']}</p>
      ) : null}
      {withoutLast.map(good => goodItem(good))}
    </div>
  );
};

const mapStateToProps = state => ({
  goods: state.currentOrder.order && state.currentOrder.order.goods,
  lastGoodId: state.app.lastGood,
  t: state.translation
});

const mapDispatchToProps = {
  changeOrder: changeCurrentOrder
};

export default connect(mapStateToProps, mapDispatchToProps)(CurrentOrder);
